import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.gsdcuser.faq.item');
import { OnInit, Input } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import showdown from 'showdown';

@Component({
    selector: 'wiz-portal-gsdcuser-faq-item',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.gsdcuser.faq.item/view.scss */
/* src/app/portal.gsdcuser.faq.item/view.scss: no such file or directory */`],
})
export class PortalGsdcuserFaqItemComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    @Input() faq_id: any;

    public tags: any = [];

    public faq: any = {};

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow(true, "/login");
        await this.load();
        await this.service.loading.hide();
    }

    public async load() {
        const { code, data } = await wiz.call("get", { id: this.faq_id });
        if (code != 200) return await this.service.alert.error("Error!");
        this.faq = data;
        this.tags = JSON.parse(this.faq.tag.replace(/'/g, '"'));
        if (this.faq.extra != null) this.faq.extra = JSON.parse(this.faq.extra.replace(/'/g, '"'));
        await this.service.render();
    }

    public showdown(text) {
        const markdown = typeof text === 'string' ? text : '';
        let converter = new showdown.Converter();
        return converter.makeHtml(markdown);
    }
}

export default PortalGsdcuserFaqItemComponent;